module.exports = __webpack_public_path__ + "static/media/toolbar_go_b_black_i.2d3154c4.png";